// extracted by mini-css-extract-plugin
export default {"closeIcon":"SBdmJbNG","icon":"Tpb17DOx","overlay":"Dm5xjemK","header":"voTMnWiH","content":"aDZ45PiX","title":"Y1LS_b6y"};